module.exports = __webpack_public_path__ + "912ec66d7572ff821749319396470bde.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
 ** module id = 678
 ** module chunks = 0
 **/